<template>
  <div>
    <list-search-form @getData="getData" />
    <student-table :loading="loading" :data="data" @getData="getData" @editScore="editScore" @resetPwd="resetPwd" />
    <common-modal v-model="showModal" :title="modalTitle">
      <score-form slot="content" v-model="currentScore" @editScoreConfirm="editScoreConfirm" v-if="modalType === 'score'" />
      <reset-pwd v-if="modalType === 'resetPwd'" :username="modalUsername" :pwd="modalPwd" @cancel="showModal = false" slot="content" />
    </common-modal>
  </div>
</template>

<script>
import listSearchForm from './listSearchForm'
import StudentTable from './studentTable'
import CommonModal from '@/components/commonModal'
import ScoreForm from './scoreForm'
import ResetPwd from './resetPwd'
export default {
  components: {
    listSearchForm,
    StudentTable,
    CommonModal,
    ScoreForm,
    ResetPwd
  },
  data() {
    return {
      data: [],
      loading: false,
      currentScore: 0,
      showModal: false,
      currentId: '',
      modalType: '',
      modalUsername: '',
      modalPwd: '',
      modalTitle: ''
    }
  },
  methods: {
    getData() {
      this.loading = true
      this.$store.dispatch('studentManageGetData').then((res) => {
        this.loading = false
        if (res.status < 400) {
          this.data = res.data.items
          this.data.forEach((value) => {
            value.initName = value.real_name
          })
        } else {
          this.data = []
        }
      })
    },
    editScore(s) {
      this.currentScore = s.row.behavior_score
      this.currentId = s.row.id
      this.modalTitle = this.$ct('classPerformance')
      this.modalType = 'score'
      this.showModal = true
    },
    editScoreConfirm(score) {
      this.$store.dispatch('studentManageEditScore', {
        id: this.currentId,
        score: score
      }).then((res) => {
        if (res.status < 400) {
          this.$message({
            type: 'success',
            message: this.$ct('csuccess')
          })
          this.showModal = false
          this.getData()
        }
      })
    },
    resetPwd(s) {
      const id = s.row.id
      this.$store.dispatch('studentManageResetPwd', id).then((res) => {
        if (res.status < 400) {
          this.modalTitle = this.$ct('resetPassword')
          this.modalUsername = s.row.username === undefined ? '-' : s.row.username
          this.modalPwd = res.data.password
          this.modalType = 'resetPwd'
          this.showModal = true
        } else {
          this.$message({
            type: 'error',
            message: this.$ct('cfail')
          })
        }
      })
    }
  },
  mounted() {
    this.$store.commit('studentManageInit')
    if (this.$route.params.class_id) {
      this.$store.commit('setState', {
        module: 'studentManage',
        key: 'class_id',
        value: this.$route.params.class_id
      })
    }
    this.getData()
  }
}
</script>
